module.exports = __webpack_public_path__ + "img/shake_top_icon.33d05fd6.png";